import { useSearchParams } from "react-router";
import { LoadingProgressBar } from "@rentablo/components";
import { NewTransactionWizard } from "./NewTransactionWizard";
import { useDepotInitialCurrency } from "./hooks/useDepotInitialCurrency";

export const NewTransactionWizardWithRouting = () => {
  const [searchParams] = useSearchParams();

  const tickerSymbol = searchParams.get("tickerSymbol");
  const quoteProvider = searchParams.get("quoteProvider");
  const depotIdParam = searchParams.get("depotId");
  const depotId = depotIdParam ? Number.parseInt(depotIdParam, 10) : undefined;

  const { initialCurrency, isLoading } = useDepotInitialCurrency(depotId);

  if (isLoading) return <LoadingProgressBar />;

  return (
    <NewTransactionWizard
      tickerSymbol={tickerSymbol!}
      quoteProvider={quoteProvider!}
      depotId={depotId}
      initialCurrency={initialCurrency}
    />
  );
};
